// Meta Pixel — Petites Histoires, Grande Foi / Le Méga Pack de Paraboles Chrétiennes
// Consentement (RGPD) : API de consentement native de Meta.
// Le pixel démarre en mode « revoke » : aucun événement n'est envoyé tant que
// la solution de consentement n'a pas appelé fbq('consent', 'grant').
// Purchase et InitiateCheckout sont volontairement absents : ils sont gérés côté checkout ImpulTienda.

type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __phgfPixelInitialized?: boolean;
  }
}

export const META_PIXEL_ID = "1387335376806060";

function loadBaseCode(): void {
  if (window.fbq) return; // déjà présent : jamais de second script

  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

// Initialise le pixel une seule fois par chargement de page et prépare PageView + ViewContent.
export function initMetaPixel(): void {
  if (typeof window === "undefined" || window.__phgfPixelInitialized) return;
  window.__phgfPixelInitialized = true;

  loadBaseCode();
  const fbq = window.fbq;
  if (!fbq) return;

  fbq("consent", "revoke");
  fbq("init", META_PIXEL_ID);
  fbq("track", "PageView");
  fbq("track", "ViewContent", {
    content_name: "Le Méga Pack de Paraboles Chrétiennes",
    content_category: "Produit numérique",
    content_type: "product",
    value: 19.9,
    currency: "EUR",
  });
}
